// Shared Google Fonts loader for CMS previews and Web Player
// Dynamically injects <link> tags for Google Fonts used in canvas objects

const SYSTEM_FONTS = new Set([
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Courier New',
  'Georgia',
  'Verdana',
  'Trebuchet MS',
  'Impact',
  'Comic Sans MS',
  'Tahoma',
  'Palatino',
  'Garamond',
  'serif',
  'sans-serif',
  'monospace',
  'cursive',
])

const loadedFonts = new Set<string>()

export function loadGoogleFontsForObjects(objects: any[]): void {
  const fontFamilies = new Set<string>()

  function collectFonts(objs: any[]) {
    for (const obj of objs) {
      if (obj.fontFamily && !SYSTEM_FONTS.has(obj.fontFamily)) {
        fontFamilies.add(obj.fontFamily)
      }
      if (obj.objects && Array.isArray(obj.objects)) {
        collectFonts(obj.objects)
      }
    }
  }

  collectFonts(objects)

  fontFamilies.forEach((fontName) => {
    if (loadedFonts.has(fontName)) return
    loadedFonts.add(fontName)
    const link = document.createElement('link')
    const encodedName = fontName.replace(/ /g, '+')
    link.href = `https://fonts.googleapis.com/css2?family=${encodedName}:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap`
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  })
}
